/** 机票分包业务文案 — 中文 */
export default {
  plane: {
    nav: {
      home: '机票首页',
      list: '机票路线',
      return: '往返',
      detail: '机票详情',
      orderFill: '创建订单',
      change: '机票改期',
      selectAddress: '选择地址',
      selectFrom: '选择出发地',
      selectTo: '选择目的地',
      passengerAdd: '新增乘机人',
      guide: '乘机指南',
      treaty: '危险品乘机说明',
      luggage: '行李规定',
      lowPrice: '国内低价',
      week: '周末拼假',
      area: '地区低价',
      remindList: '提醒列表',
      remindFlights: '航班列表',
      remindAdd: '新增提醒',
      intlOrderDetail: '订单详情',
      intlList: '国际机票路线',
      intlDetail: '国际机票详情',
      intlChangeList: '国际机票改签航班列表',
      intlChangeDetail: '改签详情',
      intlChange: '申请改签',
      intlRefund: '申请退票',
      intlRefundDetail: '退款详情',
      intlProgress: '退款进度',
    },

    common: {
      confirm: '确认',
      cancel: '取消',
      clear: '清空',
      reset: '重置',
      search: '查询',
      book: '订',
      addToCart: '添加购物车',
      addingToCart: '添加中...',
      next: '下一步',
      done: '完成',
      more: '更多',
      detail: '明细',
      expand: '展开',
      collapse: '收起',
      filter: '筛选',
      viewResults: '查看结果',
      moreSort: '更多排序',
      sortTitle: '排序方式',
      loading: '加载中...',
      noMore: '没有更多了',
      checkPrice: '查价',
      fewLeft: '少量',
      stopover: '经停',
      stopoverWithTime: '经停:{time}',
      shareFlight: '和{code} 航班号共享同一航班',
      from: '出发',
      to: '到达',
      depCity: '出发城市',
      arrCity: '到达城市',
      depDate: '出发时间',
      arrDate: '到达时间',
      daysCount: '{count}天',
      oneWay: '单程',
      roundTrip: '往返',
      multiTrip: '多程',
      outbound: '去程',
      inbound: '回程',
      returnTrip: '返程',
      outboundShort: '去',
      returnShort: '返',
      adult: '成人',
      child: '儿童',
      infant: '婴儿',
      adultChildSuffix: '{name} {type}',
      withMeals: '有餐食',
      withoutMeals: '无餐食',
      punctualityRate: '准点率{rate}',
      totalDuration: '总时长：{duration}',
      totalDurationShort: '总时长{duration}',
      remainingTickets: '剩{count}张',
      priceFrom: '￥{price}起',
      priceSuffix: '起',
      perPersonPrice: '人均价',
      totalPrice: '总价',
      payFrom: '付￥{price}起',
      discounted: '已减￥{amount}',
      discountFold: '{discount}折',
      discountFoldCompact: '{discount}折',
      specialPrice: '特价',
      standardPrice: '标准',
      standardPriceFull: '标准价',
      economyQuote: '经济舱报价',
      economy: '经济舱',
      business: '商务舱',
      businessFirst: '公务/头等舱',
      businessFirstCabin: '公务舱/头等舱',
      upgradeComfort: '升级更舒适',
      seatAngle: '角度：',
      seatAngleValue: '座椅120°',
      seatWidth: '座宽：',
      seatWidthValue: '比经济舱宽敞19%',
      directOnly: '仅看直飞',
      allDayDepart: '全天起飞',
      localTimeNote: '选择改期的日期（当地时间）',
      pendingConfirm: '待确认',
      refundChangeDetail: '退改详情',
      refundChangeLuggage: '退改签、行李额',
      refundFetchFailed: '退改规则获取失败，请稍后重试',
      refundUnavailable: '暂无法获取退改规则',
      airlinePolicyOriginal: '航空公司政策原文',
      currentPeriod: '当前时段',
      currentPrice: '当前',
      refundTaxOnly: '只退机建和燃油',
      perPerson: '/人',
      historyRecord: '历史记录',
      city: '城市',
      hotBadge: '热',
      airport: '机场',
      depAirport: '起飞机场',
      arrAirport: '到达机场',
      depAirportLabel: '起飞机场：{name}',
      arrAirportLabel: '到达机场：{name}',
      depTimeSlot: '起飞时段',
      airline: '航空公司',
      airportSection: '机场',
      noAirlineLimit: '不限航空公司',
      searchAirline: '搜索航空公司',
      noAirlineData: '暂无航空公司数据',
      selectAirline: '选择航空公司',
      collect: '收藏',
      collected: '已收藏',
      collectedFlights: '收藏的航班',
      swipeToUnfavorite: '左滑卡片可取消收藏',
      unfavorite: '取消收藏',
      collectedCount: '已收藏({count})',
      installmentFree: '分期免息',
      banksSupported: '支持40家银行',
      shareDesc: '全场分期  0利息0手续费  40家银行信任支持的平台',
      shareBooking: '他正在0息游预定{from}-{to}的机票',
      gotIt: '知道了',
      tip: '提示',
      all: '全部',
      confirmBtn: '确认',
      edit: '编辑',
      delete: '删除',
      goSee: '去看看',
      goSelectHotel: '去选酒店',
      submitOrder: '提交订单',
      payNow: '立即支付',
      selectAll: '全选',
      deselectAll: '取消全选',
      addNew: '新增',
      addPassenger: '新增乘机人',
      selectPassenger: '选择乘机人',
      noThreshold: '无门槛',
      couponDefault: '优惠券',
      noCoupon: '不使用优惠券',
      noCouponAvailable: '暂无可用优惠券',
      couponLoading: '获取优惠券中...',
      couponCount: '{count}张可用',
      couponValidUntil: '有效期至：{date}',
      couponUnusable: '当前不可用',
      bankPayOnly: '仅限{bank}支付可用',
      bankPayOnlyDefault: '仅限指定银行支付可用',
      paymentLimit: '支付限制',
      noInsurance: '无保障',
      insuranceNotice: '投保须知',
      noInvoice: '无发票',
      giveUpCoverage: '放弃保障？',
      protectTrip: '守护您的行程',
      accidentInsurance: '航空意外险',
      delayInsurance: '航空延误险',
      addProtection: '为行程添加保障',
      insuranceTagline: '出行有保险，家人更放心',
      policyholder: '投保人',
      viewEdit: '查看/修改',
      moreDiscount: '更多优惠',
      moreDiscountTitle: '更多优惠',
      agreeRead: '我已阅读并同意',
      agreeAccept: '我已阅读并接受',
      personalInfoAuth: '个人信息授权说明',
      dangerousGoodsLink: '(锂电池、充电宝及危险品乘机说明)',
      ticketFast: '出票快，1小时20分钟内完成出票',
      domesticIdOnly: '(仅显示国内证件)',
      flightHeader: '{date}{from}到{to}的航班',
      flightHeaderColon: '{date}{from}到{to}的航班：',
      routeArrow: '{from} → {to}',
      routeDash: '{from}-{to}',
      weekLabel: '周{day}',
      weekPrefix: '周',
      weekdayNames: '日,一,二,三,四,五,六',
      monthWeekend: '{month}月周末',
      weekendTitle: '{month}月周末拼假',
      maxLeaveDays: '最多请假{count}天',
      playDays: '玩{min}-{max}天',
      askLeave: '请假',
      weekend: '周末',
      askDays: '请{count}天',
      playDaysShort: '玩{count}天',
      roundTotal: '往返总价',
      weekN: '第{count}周',
      updatedAt: '更新于{time}',
      moreStrategies: '更多拼假攻略',
      priceLowToHigh: '价格低-高',
      dateEarlyToLate: '日期早-晚',
      departSuffix: '出发',
      goDepart: '{date} {weekday}出发',
      carrierOffer: '航司专属优惠',
      departFrom: '{city}出发',
      endOfList: '已经到底了，换个城市看特价航班吧~',
      endOfLuggage: '这里是「行李规定」的末尾啦',
      tapCategoryHint: '点击上方分类切换查看不同内容',
      lastChapter: '已经到最后一章啦',
      allowCheckin: '允许托运',
      allowCarry: '允许携带',
      forbidCheckin: '禁止托运',
      forbidCarry: '禁止携带',
      forbidHandCarry: '禁止手提',
      restrictCheckin: '限制性托运',
      restrictCarry: '限制性手提',
      commonItems: '常见物品',
      note: '注意',
      remark: '备注',
      exampleOnly: '示例仅供参考,具体以机场及航司规定为准',
      domesticLuggageTitle: '国内乘机行李规定',
      travelReminder: '出行提醒>',
      expandReminder: '展开提醒',
      tableColTime: '时间',
      tableColFee: '手续费',
      selectAirport: '选择机场',
      singleSelect: '单选',
      multiSelect: '多选',
      airportSuffix: '(机场)',
    },

    date: {
      today: '今天',
      tomorrow: '明天',
      dayAfter: '后天',
      weekdaySun: '周日',
      weekdayMon: '周一',
      weekdayTue: '周二',
      weekdayWed: '周三',
      weekdayThu: '周四',
      weekdayFri: '周五',
      weekdaySat: '周六',
      monthDay: '{month}月{day}日',
      monthDayDash: '{month}-{day}',
      monthDayWeek: '{month}月{day}日 {weekday}',
      yearMonthDay: '{year}-{month}-{day}',
      yearMonthDayWeek: '{year}年{month}月{day}日 {weekday}',
      dateRange: '{start}至{end}出发',
      dateRangeShort: '{start}至{end}',
      returnDate: '返程日期',
      departDate: '出发日期',
      calendarOutbound: '去程',
      calendarReturn: '返程',
      calendarBoth: '去程/返程',
      calendarNotSelected: '未选择',
      calendarTripN: '选择第{n}程日期',
      calendarTip: '所选日期为出发地日期，显示成人价，变价频繁以实际支付价为准',
      selectDepartDate: '选择出发日期',
      selectRoundDate: '选择往返日期',
      outboundLabel: '去：',
      returnLabel: '返：',
      nightBadge: '夜间',
    },

    sort: {
      lowPriceFirst: '低价优先',
      directFirst: '直飞优先',
      departEarlyLate: '起飞早⇀晚',
      departLateEarly: '起飞晚⇀早',
      arriveEarlyLate: '到达早⇀晚',
      arriveLateEarly: '到达晚⇀早',
      shortestDuration: '耗时短优先',
      timeSort: '时间排序',
      priceSort: '价格排序',
      priceLowToHigh: '价格低到高',
      priceHighToLow: '价格高到低',
      timeEarlyToLate: '时间早到晚',
      timeLateToEarly: '时间晚到早',
    },

    filter: {
      title: '筛选',
      depTimeSlot: '起飞时段',
      airline: '航空公司',
      airport: '机场',
      depAirport: '起飞机场',
      arrAirport: '到达机场',
    },

    list: {
      empty: '当前搜索无结果',
      returnSearchEmpty: '查不到相关的航班信息，请稍后重试',
      timeoutTitle: '搜索结果已超时',
      timeoutDesc: '您已在此页停留超时，为您获取新航班报价，请重新查询',
      noFlightsFound: '暂未查询到航班信息~',
      elderHeader: '{date}{from}到{to}的航班：',
      rtTotalPrice: '往返总价',
      flightDetail: '航班详情',
      selectOutboundFirst: '请先选择去程航班',
      selectReturnFirst: '请选择返程航班',
      priceDelta: '+¥{price}',
      includeShare: '含共享',
      saveVsSeparate: '比分开订省¥{amount}',
    },

    detail: {
      refundRulesTitle: '退票收费规则',
      changeRulesTitle: '改期手续费规则',
      transferRulesTitle: '签转其他航空公司条件',
      freeLuggageTitle: '免费行李规定',
      adultChildBoth: '成人、儿童',
      adultBracket: '【成人】',
      childBracket: '【儿童】',
      outboundTab: '去程说明',
      returnTab: '返程说明',
      tabPriceFrom: '￥{price}起',
      outboundPolicy: '去程',
      returnPolicy: '返程',
      travelAlert: '行程提醒：',
      cabinEconomyTab: '经济舱报价',
      cabinBusinessTab: '公务/头等舱',
    },

    home: {
      tabDomestic: '机票',
      tabIntl: '国际机票',
      tabSpecial: '特价机票',
      wayOneWay: '单程',
      wayRound: '往返',
      wayMulti: '多程',
      searchFlights: '机票查询',
      searchSpecial: '查询特价',
      searchBtn: '查询',
      passengerSummary: '{adult}成人 {child}儿童 {infant}婴儿',
      withChild: '带儿童',
      withInfant: '带婴儿',
      childAgeHint: '2-12岁',
      infantAgeHint: '14天-2岁',
      childInfantGuide: '儿童婴儿预订说明',
      childInfantGuideLink: '婴童预订说明>',
      adultAgeRule: '>12周岁(含)',
      childAgeRule: '2周岁(含)-12周岁(不含)',
      infantAgeRule: '14天(含)-2周岁(不含)',
      intlChildRule1: '·每名成人最多可携带1名（儿童+婴儿）',
      domesticChildRule1: '·每名成人最多可携带2名儿童和1名婴儿',
      pricePerPersonNote: '·搜索结果将显示{n}人的均价（不含机建燃油）',
      priceTotalNote: '·搜索结果将显示{n}人的总价（含机建燃油）',
      addLeg: '再加一程',
      addLegTip: '(最多可添加5程)',
      airlineLabel: '航空公司',
      specialDepart: '出发：{range}',
      flightGuideTitle: '飞行贴士',
      flightGuideDesc: '为您搜罗最全乘机指南',
      flightGuideMore: '更多 >',
      specialZone: '特卖专区',
      weekendCheap: '周末飞哪儿便宜',
      monitoring: '7×24小时监控',
      lowPriceDetected: '今日已为{count}人检测到低价',
      watchRoutes: '关注的航线',
      watchRoutesTip: '| 航线若降价，立即通知您',
      monitoringStatus: '正在监控',
      priceRising: '预测价格持续上涨 | 尽快购买以防涨价',
      ticketsTight: '余票紧张',
      swipeEditDelete: '←左滑可删除/编辑监控',
      swipeDelete: '←左滑可删除监控',
      addLowPriceAlert: '添加低价提醒',
      addReminderBanner: '添加提醒，一降价就通知',
      addReminder: '添加提醒',
      viewMore: '查看更多',
      detectNearby: '同时检测临近日期的航班',
      followFavorite: '同时关注喜欢的航班',
      favoriteDropAlert: '航班一降价就通知',
      cabinEconomy: '经济舱',
      cabinBusinessFirst: '公务舱/头等舱',
      loadingAirlines: '加载中...',
      elderDepCity: '出发城市',
      elderArrCity: '到达城市',
      elderDepDate: '出发时间',
      elderArrDate: '到达时间',
      inspirationFrom: '{city}出发的灵感',
      weekStrategyTitle: '假期怎么拼最划算？',
      weekStrategy: '拼假攻略',
      lowPriceAlertTitle: '降价立刻通知我？',
      lowPriceAlert: '低价提醒',
      goSee: '去看看',
      localGuide: '当地玩法攻略',
      featuredRecommend: '精选推荐',
      roundTripTotal: '往返总价',
      weekN: '第{count}周',
      updatedAt: '更新于{time}',
      askLeave: '请假',
      playDaysShort: '玩{count}天',
      departFrom: '{city}出发',
      shareFlashTitle: '免息抢票·限时破底',
      selectCity: '选择城市',
    },

    change: {
      stepApply: '改期申请',
      stepSelectFlight: '选择航班',
      stepSelectCabin: '选择舱位',
      selectPassengers: '选择改期的乘客',
      selectItinerary: '选择改期的行程',
      selectDateLocal: '选择改期的日期（当地时间）',
      viewFlights: '查看航班',
      priceDetailTitle: '价格详情',
      actualPay: '实际支付',
      adultDiff: '成人差价',
      childDiff: '儿童差价',
      changeFeeAdult: '改期价',
      changeFeeChild: '儿童改期价',
      step01: '01',
      step02: '02',
      step03: '03',
    },

    order: {
      priceDetail: '价格明细',
      priceLine: '票价￥{ticket} 机建+燃油￥{tax}',
      passengers: '乘机人',
      passengerInfo: '乘机人信息',
      contactReceiver: '订单通知接收人',
      contactPhone: '联系电话',
      contactPlaceholder: '用于接收机票预订信息',
      contactPlaceholderShort: '用于接受订单/航变信息',
      hotelBundleTitle: '加订酒店',
      hotelBundleTitleLong: '加订酒店，享最高12期免息分期',
      hotelBundleDesc: '机票+酒店组合预订更优惠',
      hotelBundleDescLong: '机票+酒店组合下单，更多优惠',
      name: '姓名',
      namePlaceholder: '与乘机证件一致',
      idNumber: '证件号码',
      idNumberPlaceholder: '请输入证件号码',
      mobilePlaceholder: '请输入手机号码',
      idCard: '身份证',
      householdRegister: '户口簿',
      noChildSupport: '当前航班不支持儿童乘客',
      amountDetail: '金额明细',
      priceDetails: '费用明细',
      expandPassengers: '展开全部{count}人',
      installmentPeriod: '{count}期',
      totalDiscount: '共减￥{amount}',
      ticketFee: '机票',
      airportTax: '机建',
      fuelSurcharge: '燃油',
      productWithTax: '{product}（含机建燃油）',
      contactInfoTitle: '联系人信息说明',
      contactInfoBody: '该联系人信息将用于接受订单发生变动的相关通知，包括航班调配、空中管制、天气原因、机械故障、航班取消等。',
      contactInfoNote: '注：订单变动包括飞机调配、空中管制、天气原因、机械故障、航班取消等。',
      selectIdType: '请选择证件类型',
      otherOptions: '其他选择',
      allIdTypes: '所有证件',
      infantIdTip: '婴儿：订票可使用身份证、护照、户口簿、出生证明',
      childIdTip: '儿童：订票可使用身份证、护照、户口簿',
      taxFuelExplainTitle: '机建燃油费说明',
      taxFuelExplainIntro: '机建燃油费包含两项费用：机场建设费和燃油附加费',
      taxFuelAirportTitle: '1.机场建设费',
      taxFuelAirportBody:
        '依据财政部、中国民航总局发出的通知，从2004年8月1日起，旅客购买从中国境内机场起飞的国内、国际和港澳台地区航班机票时，需一并随机票缴纳机场管理建设费。机场管理建设费在机票价外单列项目反映，其征收范围和标准按现行有关规定执行。',
      taxFuelFuelTitle: '2.燃油附加费',
      taxFuelFuelAfterDate: '2024年10月5日(出票日期)0时后',
      taxFuelFuelAfterRule1:
        '一、国内航线旅客运输燃油附加费收取标准，800公里(含)以下航段，每位旅客收取人民币10元;800公里以上航段，每位旅客收取人民币20元。',
      taxFuelFuelAfterRule2: '二、按规定享受国内民航成人普通票价10%的婴儿，免收燃油附加费。',
      taxFuelFuelAfterRule3:
        '三、按规定购买国内民航成人普通票价50%的儿童(含无成人陪伴儿童)、革命伤残军人和因公致残的人民警察，旅客运输燃油附加费收取标准为，800公里(含)以下航段，免收燃油附加费:800公里以上航段，每位旅客收取人民币10元。',
      taxFuelFuelBeforeDate: '自2024年10月5日(出票日期)0时前',
      taxFuelFuelBeforeRule1:
        '一、国内航线旅客运输燃油附加费收取标准，800公里(含)以下航段，每位旅客收取人民币30元;800公里以上航段，每位旅客收取人民币50元。',
      taxFuelFuelBeforeRule2: '二、按规定享受国内民航成人普通票价10%的婴儿，免收燃油附加费。',
      taxFuelFuelBeforeRule3:
        '三、按规定购买国内民航成人普通票价50%的儿童(含无成人陪伴儿童)、革命伤残军人和因公致残的人民警察，旅客运输燃油附加费收取标准为，800公里(含)以下航段，每位旅客收取人民币10元;800公里以上航段，每位旅客收取人民币20元。',
      personalInfoTitle:
        '尊敬的用户，感谢您使用0息游的机票预订业务，具体的服务将由境内/境外航空公司向您提供。',
      contactInfoBodyLong:
        '该联系人信息将用于接受订单发生变动的相关通知，建议您填写您本人的手机号码，以便能够第一时间接收到订单变化通知，以免影响您的出行体验~',
      contactInfoNoteLong:
        '注：订单变动包括飞机调配、空中管制、机场原因、天气原因、上座率等原因导致的航班时刻更改、取消或航班合并等',
      passengerIdNoticeFill:
        '根据航空公司要求，购买机票需提交乘机人身份证件信息,并在乘机时出具对应身份证件用于验证，请确保录入信息真实有效。0息游出行将通过加密等方式保护您录入的身份证件信息，且在具体订票过程中授权提供给您提供服务的产品供应商、承运人、机票分销系统服务商。',
      adultPriceWithTax: '成人￥{ticket} +机建燃油￥{tax}',
      childPriceWithTax: '儿童￥{ticket} +机建燃油￥{tax}',
      adultCountShort: '{count}成人',
      childCountShort: '{count}儿童',
      priceTimesCount: '￥{price}×{count}',
      priceTimesPersonCount: '￥{price}×{count}人',
      noCouponShort: '暂无可用',
      specifiedBank: '指定银行',
      flightPopupDuration: '{date} 总时长{duration}',
      couponFullReduction: '满{minAmount}减{amount}',
      couponInstantReduction: '立减{amount}元',
      couponFullDiscount: '满{minAmount}享{discount}折',
      couponDiscountOff: '{discount}折优惠',
      delayInsuranceShort: '航班延误险',
      routeConnector: '一',
      selectPolicyholder: '选择投保人',
      policyholderAgeTip: '投保人需年满18周岁',
      addPolicyholder: '新增投保人',
      coverageContent: '保障内容',
      insuranceDetail: '保险详情',
      invoice: '发票',
      selectCoupon: '选择优惠券',
      policyholderExplain: '投保人是与保险公司签订合同，有支付保险义务的人，须大于18周岁',
      changeCouponWarn: '更换后您可能将不再享有免息分期权益，您确认更换吗？',
      keepChange: '不更换',
      confirmChange: '确认更换',
      noInvoiceInsurance: '该险种暂不可开发票',
      cancelCouponWarn: '取消后您可能将不再享有免息分期权益，您确认取消吗？',
      keepCoupon: '不取消',
      confirmCancelCoupon: '确认取消',
      personalInfoBody: "尊敬的用户，感谢您使用0息游的机票预订业务，具体的服务将由境内/境外航空公司向您提供。您理解，在您预订国内机票时，0息游需将订单信息确认页中涉及的您勾选的产品信息与您输入或勾选的个人信息提供给为您提供服务的境内航空公司；在您预订国际机票时，您的前述个人信息会提供给您预订的境外航空公司，以供其核实您的身份、确认您的订单，并最终为您提供服务。（您可以通过预订页面底部查阅出票方公司名称和营业执照信息，您也可以通过预订详情页面底部的蓝色超链接浏览航空公司运输条件并查询航空公司名称和联系方式）。在提供有关信息前，0息游将严格执行《中华人民共和国个人信息保护法》以及0息游《个人信息保护政策》的规定，要求有关服务提供方切实履行个人信息保护义务，仅就提供服务之目的处理您的个人信息，不得擅自转移、共享、提供、出售或基于其他目的处理您的个人信息。我们还设立了个人信息保护专职部门，有关您个人信息的权利请求，包括个人信息出境场合向境外接收方主张个人信息权利的请求，均可以发送邮件至个人信息保护负责人的邮箱wujinbao{'@'}wujinbao.net与我们联系。请您再次审慎核实确认您勾选的产品信息与您输入或勾选的个人信息。若您点击【提交订单】，表示您同意0息游基于为您提供服务之目的，向有关【境内/境外】服务提供方提供您的个人信息。",
      passengerIdNotice: '根据航空公司要求，购买机票需提交乘机人身份证件信息，并在办理乘机手续时出示与购票时一致的证件原件。',
      adultCount: '成人{count}人',
      childCount: '儿童{count}人',
      fillOrder: '填写订单',
      agreeTreatyPrefix: '我已阅读并接受',
      agreeTreatySuffix: '、',
      agreePersonalInfo: '个人信息授权说明',
    },

    passenger: {
      cardType: '证件类型',
      nationality: '国籍',
      selectNationality: '请选择国籍',
      surname: '姓',
      surnamePlaceholder: '请输入姓（拼音/英文）',
      givenName: '名',
      givenNamePlaceholder: '与乘机证件一致',
      givenNameIntlPlaceholder: '请输入名（拼音/英文）',
      cardExpired: '证件有效期至',
      selectCardExpired: '请选择证件有效期至',
      birthday: '出生日期',
      selectBirthday: '请选择出生日期',
      gender: '性别',
      male: '男',
      female: '女',
      email: '邮箱',
      emailPlaceholder: '请填写邮箱',
      issuingAirline: '发卡航司',
      selectAirlineOptional: '请选择航司(选填)',
      frequentFlyerNo: '常旅客卡号',
      frequentFlyerPlaceholder: '请填写常旅客卡号(选填)',
      readCarefully: '请您仔细阅读并理解以下内容',
      savePassenger: '新增乘机人',
      editPassenger: '修改乘机人',
      savePolicyholder: '新增投保人',
      editPolicyholder: '修改投保人',
      selectCardType: '请选择证件类型',
      selectAreaCode: '请选择区号',
      searchCountry: '搜索国家',
      searchAreaCode: '搜索区号',
      searchAirline: '搜索航司',
      loadingMore: '加载更多...',
      noMoreData: '没有更多数据了',
      selectAirport: '选择机场',
      datePickerYear: '年',
      datePickerMonth: '月',
      datePickerDay: '日',
      cardTypeNI: '居民身份证',
      cardTypePP: '护照',
      cardTypeOT: '其它',
      cardTypeHM: '港澳台居住证',
      cardTypeHMP: '港澳通行证',
      cardTypeHR: '户口簿',
      cardTypeHX: '回乡证',
      cardTypeTB: '台胞证',
      cardTypeTP: '台湾通行证',
      cardTypeJR: '军人证',
      cardTypeBC: '出生证明',
    },

    select: {
      searchCity: '请输入城市',
      tabDomestic: '国内城市',
      tabHmt: '中国港澳台',
      tabOverseas: '境外',
      currentHistory: '当前/历史',
      currentNearbyTitle: '当前城市 / 邻近机场',
      historyTitle: '历史 (含国内、国际/中国港澳台)',
      straightLineDistance: '直线距离 {distance}KM',
      clearHistory: '清除历史',
      hotCities: '热门城市',
      confirmMulti: '确认',
      maxThree: '选项最多可选3个',
      alreadySelected: '您已选择此项了',
      sameCityError: '出发地和目的地不能相同',
      intlSameMainlandError: '国际机票的出发地和目的地不能同时为中国大陆城市',
      noAirportInfo: '该城市无机场信息，将直接选择城市',
      loadCityFailed: '获取城市列表失败',
      loadContinentFailed: '获取大洲列表失败',
      loadCountryFailed: '获取国家列表失败',
      searchFailed: '搜索失败',
      loadAirportFailed: '获取机场列表失败',
      searchSectionAirport: '机场',
      searchSectionCity: '城市',
      searchSectionCountry: '国家/地区',
      searchSameCityTag: '同城',
    },

    guide: {
      title: '乘机指南',
      subtitle: '覆盖购票、安检、登机全流程的小贴士',
      tabBuy: '购买机票',
      tabAirport: '到达机场',
      tabSecurity: '安检登机',
      tabBoarding: '准备登机',
      tabChangeRefund: '退改期',
      fraudAlert: '【重要提醒】近期诈骗事件频现，如果您收到任何退改签、航班变动短信或电话，请联系航空公司或0息游核实。索要银行卡密码、验证码均为诈骗手段。',
      servicePhone: '0息游电话：{phone}',
      buy: {
        title: '购买机票',
        body: '购买机票并成功出票后您还需要确认出发机场和航站楼，以北京为例，目前就有大兴机场和首都机场2个机场，而首都机场又分为T1、T2、T3三个航站楼不同的航空公司出发航站楼不同，一定注意出票订单提示的航站楼，不要因为走错机场耽误了行程~',
      },
      airport: {
        title: '到达机场',
        arriveTimeTitle: '到达时间',
        arriveTimeBody: '国内出发通常需要在航班起飞前2小时到达机场',
        validIdTitle: '有效证件',
        validIdBody: '居民身份证则需要携带相应的原件、如儿童购票时使用的户口本则需要携带儿童户口本原件注意:若忘记携带证件，可本人到机场的公安处开具一份临时登记证明',
        boardingPassTitle: '登机牌&行李托运',
        boardingPassBody: '拿好有效证件原件在所购机票相应的航空公司机场柜台换取登机牌(柜台具体位置在机场都有引导指示牌或可以询问机场地勤人员)，如有行李需要托运换登机牌的同时在航空公司柜台办理行李托运手续',
        powerBankTitle: '充电宝&行李大小',
        powerBankBody: '充电宝只能随身携带，不可托运(且不超过20000毫安)，通常情况，国内航班经济舱可免费托运的行李额为20Kg，登机可随身携带行李尺寸不超过20X40X55厘米，重量不超过5kg 注意:不同航司规定不同，具体可查看机票订单详情或联系航司询问;如需购买行李额，可在航司官网或机场购买',
      },
      security: {
        title: '安检登机',
        intro: '携带登机牌以及购票时使用的有效证件，通过安检通道接受安检后进入候机大厅',
        dailyItemsTitle: '日用品规则',
        dailyItemsBody1: '国内航班可携带容积每件不超过100毫升的洗面奶、洗发水、牙膏等液状物乘机，超过此规格需要办理托运。需注意，50毫升洗发水装在150毫升的瓶子里也是不允许的;',
        dailyItemsBody2: '如需携带药品、植物、小动物等特殊物品请联系航空公司咨询;',
        dailyItemsBody3: '禁止携带任何饮料、酒精、打火机和剪刀等生活用刀乘机;',
      },
      boarding: {
        title: '准备登机',
        body: '根据登机牌上的标识，在候机大厅对应的登机口等待乘机，根据登机牌上的登机口和登机时间提示，在候机大厅对应的登机口等待登机',
      },
      changeRefund: {
        title: '退改期',
        itineraryChangeTitle: '行程有变',
        itineraryChangeBody: '若行程有变，选择对应的机票订单，进行申请退票或改期',
        feeTitle: '退改签费用',
        feeBody: '具体规定请查看订单详情中的【退改签规则】',
      },
    },

    treaty: {
      heroTag: '安全出行提示',
      heroTitle: '危险品乘机说明',
      heroDesc: '出发前请仔细阅读锂电池、充电宝及危险品携带规定，遵守要求才能顺利登机。',
      section1: {
        title: '一、关于民航旅客行李中携带锂电池规定的公告',
        badge: '锂电安全',
        p1: '为了加强旅客行李中锂电池的航空运输安全，民航局、民航华东地区管理局先后下发《关于加强旅客行李中锂电池安全航空运输的通知》，要求民航各相关单位进一步做好旅客行李中锂电池的安全运输管理工作，对于旅客行李中携带锂电池的，按照国际民航组织《危险物品安全航空运输技术细则》以下规定执行：',
        p2: '旅客或机组成员为个人自用内含锂或锂离子电池或电池的便携式电子装置(锂电池移动电源、手表、计算器、照相机、手机、手提电脑、便携式摄像机等)应作为手提行李携带登机，并且锂金属电池的锂含量不得超过2克，锂离子电池的额定能量值不得超过100Wh(瓦特小时)。超过100Wh但不超过160Wh的，经航空公司批准后可以装在手提行李中的设备上。超过160Wh的锂电池严禁携带。',
        p3: '便携式电子装置的备用电池必须单个做好保护以防短路(放入原零售包装或以其他方式将电极绝缘，如在暴露的电极上贴胶带，或将每个电池放入单独的塑料袋或保护盒当中)，并且仅能在手提行李中携带。经航空公司批准的100-160Wh的备用锂电池只能携带两个。',
        p4: '飞行过程中装有启动开关的锂电池移动电源(充电宝)，应当确保开关处于关闭状态。不得使用移动电源为消费电子设备充电或作为外部电源使用;不得开启移动电源的其他功能。',
        p5: '旅客和机组成员携带锂离子电池驱动的轮椅或其他类似的代步工具和旅客为医疗用途携带的、内含锂金属或锂离子电池芯或电池的便携式医疗电子装置的，必须依照《危险物品安全航空运输技术细则》的运输和包装要求携带并经航空公司批准。',
      },
      appendix: {
        title: '附: 锂电池安全运输提示',
        badge: '操作细则',
        allowedTitle: '一、可携带的锂电池',
        allowedP1: '可以作手提行李携带含不超过100wh(瓦特小时)锂电池的笔记本电脑、手机、照相机、手表等个人自用便携电子设备及备用电池登机。',
        allowedP2: '一般来讲，手机的锂电池额定能量多在3~10Wh;单反照相机锂电池的能量多在10~20Wh;便携式摄像机的锂电池能量多在20-40Wh;笔记本电脑的锂电池能量为30-100Wh多不等。因此，手机、常用便携式摄像机、单反照相机以及绝大多数手提电脑等电子设备中的锂电池通常不会超过100Wh的限制。',
        restrictedTitle: '二、限制携带的锂电池',
        restrictedP1: '经航空公司批准，可以携带含超过100Wh但不超过160wh锂电池的电子设备登机。每位旅客携带此类备用电池不能超过两个，且不能托运。',
        restrictedP2: '可能含有超过100Wh锂电池的设备如新闻媒体器材、影视摄制组器材、演出道具、医疗器材、电动玩具、电动工具、工具箱等。',
        forbiddenTitle: '三、禁止携带的锂电池',
        forbiddenP1: '禁止携带或托运超过160Wh的大型锂电池或电子设备。',
        protectTitle: '四、备用锂电池的保护措施',
        protectP1: '备用电池必须单个做好保护以防短路(放入原零售包装或以其他方式将电极绝缘，如在暴露的电极上贴胶带，或将每个电池放入单独的塑料袋或保护盒当中)。',
        calcTitle: '五、锂电池额定能量的判定方法',
        calcP1: '若锂电池上没有直接标注额定能量Wh(瓦特小时)，则锂电池额定能量可按照以下方式进行换算:',
        calcP2: '1.如果已知电池的标称电压(V)和标称容量(Ah)，可以通过计算得到额定瓦特小时的数值:Wh=V x Ah，标称电压和标称容量通常标记在电池上。',
        calcP3: '2.如果电池上只标记有毫安时(mAh)，可将该数值除以1000得到安培小时(Ah)。例如:锂电池标称电压为3.7V标称容量为760mAh，其额定瓦特小时数为：760mAh/1000=0.76Ah；3.7V x 0.76Ah=2.9Wh',
      },
      powerBank: {
        title: '关于民航旅客携带"充电宝"乘机规定的公告',
        badge: '充电宝指引',
        intro: '充电宝是指主要功能用于给手机等电子设备提供外部电源的锂电池移动电源。根据现行有效国际民航组织《危险物品安全航空运输技术细则》和《中国民用航空危险品运输管理规定》，旅客携带充电宝乘机应遵守以下规定：',
        rule1: '一、充电宝必须是旅客个人自用携带。',
        rule2: '二、充电宝只能在手提行李中携带或随身携带，严禁在托运行李中携带。',
        rule3: '三、充电宝额定能量不超过100Wh,无需航空公司批准；额定能量超过100Wh但不超过160Wh，经航空公司批准后方可携带，但每名旅客不得携带超过两个充电宝。',
        rule4: '四、严禁携带额定能量超过160Wh的充电宝；严禁携带未标明额定能量同时也未能通过标注的其他参数计算得出额定能量的充电宝。',
        rule5: '五、不得在飞行过程中使用充电宝给电子设备充电。对于有启动开关的充电宝，在飞行过程中应始终关闭充电宝。',
        rule6: '上述规定同时适用于机组人员。',
        rule7: '本公告自公布之日起施行。',
        calcTitle: '附:充电宝额定能量的判定方法',
        calcP1: '若充电宝上没有直接标注额定能量Wh(瓦特小时)，则充电宝额定能量可按照以下方式进行换算：',
        calcP2: '1、如果已知充电宝的标称电压(V)和标称容量(Ah)，可以通过计算得到额定能量的数值：Wh= V x Ah标称电压和标称容量通常标记在充电宝上。',
        calcP3: '2、如果充电宝上只标记有毫安时(mAh)，可将该数值除以1000得到安培小时(Ah)。例如：充电宝标称电压为3.7V，标称容量为760 mAh，其额定能量为：760 mAh ÷ 1000 = 0.76Ah，3.7V × 0.76Ah=2.9Wh',
      },
      section2: {
        title: '二．禁止携带危险品乘机',
        badge: '必读提醒',
        p1: '携带具有隐含危险性的相关物品，请向航空公司或机场客服人员咨询。',
        p2: '酒类、液态日用品和自用含锂电池便携设备及其备用锂电池等物品应按民航相关规定携带。',
      },
      balanceCar: {
        title: '关于明确旅客携带小型锂电池动力车运输规定的通知',
        badge: '动力车提示',
        body: '鉴于电动平衡车采用的锂电池有火灾隐患，为确保飞行安全，禁止旅客携带或托运以锂电池为动力的电动平衡车乘机。电动平衡车是指以锂电池为动力，可载人的，单轮或多轮的移动辅助工具，包括但不仅限于：独轮车、电动滑板、风火轮、智能代步车、体感车、思维车、摄位车等。',
      },
    },

    luggage: {
      title: '行李规定',
      domesticTitle: '国内乘机行李规定',
      subtitle: '示例仅供参考,具体以机场及航司规定为准',
      tabs: {
        common: '常用物品',
        electronics: '家电数码',
        toiletries: '日化用品',
        food: '食品',
        special: '特殊行李',
        tools: '工具',
      },
      table: {
        itemName: '物品名称',
        carryOn: '随身携带',
        checked: '托运',
        sectionTitle: '常用物品哪些不能带?',
      },
      status: {
        allowed: '✓',
        forbidden: '✗',
      },
      commonItems: {
        lighter: { name: '打火机、火柴' },
        selfHeating: { name: '自嗨锅等发热食物' },
        sprayCan: { name: '防晒喷雾等金属压力罐' },
        disinfectant: { name: '含异丙醇医用消毒剂' },
        powerBank: { name: '充电宝', carry: '≤2万毫安' },
        electricToothbrush: { name: '电动牙刷' },
        phone: { name: '手机' },
        earphones: { name: '蓝牙耳机', carry: '请勿在起飞/降落状态中使用' },
        laptop: { name: '笔记本电脑 平板电脑', check: '部分航司关机可托运' },
        dailyKnife: { name: '日用刀具' },
        longUmbrella: { name: '超过1米的雨伞' },
        thermometer: { name: '水银体温计', check: '有保护壳情况下可托运一支' },
        cosmetics: { name: '液体洗护 化妆品', carry: '容器容积 ≤100ML', check: '无易燃易爆标志' },
        alcohol: { name: '酒类', check: '限制度数、体积' },
        selfieStick: { name: '自拍杆 相机脚架', carry: '收合后长度<25cm 且管径<1cm' },
        liquidMedicine: { name: '胰岛素等 液态药品', carry: '根据飞行时长适量携带且最好出具医疗机构的相关证明' },
        medicalMask: { name: '医用口罩 护目镜、防护服' },
        handWarmer: { name: '暖宝宝', carry: '以航司/机场安检规定为准', check: '以航司/机场安检规定为准' },
        jewelry: { name: '珠宝首饰等 贵重物品', check: '不建议托运 建议随身携带' },
      },
      electronics: {
        powerBankTitle: '充电宝',
        noElectronicsTitle: '不含锂电池的电器',
        samsungTitle: '三星 Galaxy Note 7 手机',
        noElectronicsItems: '插电型吹风机、卷发棒、夹板、使用干电池的电动牙刷等。',
        powerBankRules: {
          r1: '民航局规定:自2025年6月28日起禁止旅客携带没有3C标识、3C标识不清晰、被召回型号或批次的(具体见下注意点1)上飞机',
          r2: '充电宝只能随身携带,不能办理托运,并且在飞行途中应确保其始终在关闭状态。',
          r3: '可以携带额定能量小于等于100Wh的充电宝(一般单个不超20000毫安,但需注意必须小于等于5伏的充电宝);',
          r4: '额定能量超过100Wh,但不超过160Wh,需要经过航空公司批准(由现场判断)才可携带;',
          r5: '大于160Wh无法携带(一般单个不超32000毫安)。额定能量计算公式:额定能量(瓦时Wh) = 电压(伏特V)*额定容量(安培/小时A/h)如:某充电宝标示额定容量为1万毫安,电压为5伏。则额定能量计算:10000mA=10A (1000mA=1A), 10A*5V=50Wh,小于100Wh,旅客可随身带上飞机。',
        },
        recallIntro: '召回型号或批次的充电宝(截止2025/6/24):',
        recallRomoss: '罗马仕(ROMOSS):',
        recallRomoss1: '①型号PAC20-272, 生产批次: C14-P6/P7、M14-P6/P7、C13-P6/P7、M20-Q1/Q2、M14-Q1/Q2、C14-Q1/Q2',
        recallRomoss2: '②型号:PAC20-392, 生产批次: M14-Q6/Q7、C13-Q6/Q7、M20-Q6/Q7、M22-Q6/Q7;',
        recallRomoss3: '③型号:PLT20A-152、生产批次: M20-P8/Q1;',
        recallAnker: '安克创新(Anker)移动电源证书暂型号:',
        recallAnkerModels: 'A1642/A1647/A1652/A1680/A1681/A1689/A1257',
        note2: '充电宝必须随身携带,严禁在托运行李中携带',
        note3: '每名旅客不得携带超过两个充电宝,必须单个做好保护以防短路',
        note4: '在外包装上有明确注明电池的容量、电压等参数能计算得出额定能量的充电宝,否则禁止携带',
        note5: '必须完全关闭且不得在飞行中使用;必须采取措施防止意外启动并保护装置不受损坏',
      },
      toiletries: {
        liquidItemsTitle: '含液体的物品',
        liquidRule: '每种化妆品限带一件,其容器容积不可超过100ml或100g且总量不可超过1000ml,准备接受开瓶检查',
        flammableTitle: '含易燃易爆物质',
        flammableR1: '部分机场不允许托运',
        flammableR2: '防晒喷雾等金属压力罐包装禁止托运',
        categories: {
          liquid: '水状',
          liquidItems: '爽肤水、洗手液、精华、化妆水、漱口水、隐形眼镜护理液',
          cream: '乳状',
          creamItems: '洗面奶、身体乳、沐浴露、洗发水',
          oil: '油状',
          oilItems: '卸妆油、精油、润滑剂、护肤油',
          paste: '霜状',
          pasteItems: '面霜、防晒霜',
          ointment: '膏状',
          ointmentItems: '牙膏、剃须膏、凡士林、药膏、睫毛膏',
          gel: '凝胶',
          gelItems: '芦荟胶',
          spray: '喷雾',
          sprayItems: '非压力罐包装的补水喷雾',
          foam: '泡沫',
          foamItems: '剃须泡沫等',
          sheet: '片状',
          sheetItems: '面膜、湿纸巾等',
          flammable: '易燃物质',
          flammableItems: '花露水、风油精、降温喷雾、香水、免洗洗手液、指甲油、洗甲水、泡沫发蜡等',
          explosive: '易爆物质',
          explosiveItems: '金属压力罐包装物品或标有易燃易爆标识如发胶、摩丝、防晒喷雾等',
        },
      },
      food: {
        freshTitle: '生鲜食品',
        freshRule: '带有明显异味的鲜活易腐食品禁止托运和携带,其他视航司和机场安检规定为准',
        sameAsCheckin: '同托运限制',
        freshItems1: '明显异味的鲜活易腐物品:生鸡蛋、榴莲、非密封腊味等',
        freshItems2: '含有液体且超过100ml的:椰子等',
        selfHeatingTitle: '自发热食品',
        selfHeatingItems: '自发热火锅,自发热盖饭',
        liquidFoodTitle: '液体类食品',
        liquidFoodItems: '固体火锅底料、冰淇淋、龟苓膏、蜂蜜、食用油、辣椒酱、豆瓣酱、罐头、酒心巧克力、水、饮料、辣酱、酸菜等。',
        liquidFoodNote: '机上供有热水,父母如果想在飞机上给孩子喂奶,可在飞机上直接用热水冲泡奶粉,也可联系航空公司申请免费液态乳制品或婴儿餐。',
        alcoholTitle: '酒类',
        alcoholR1: '标识清晰且置于零售包装袋内且容器容积不超过5L。',
        alcoholR2: '24度以下托运不受限制。',
        alcoholR3: '24度(不含24度)至70度(含70度)每位旅客托运总数量不超过5L。',
        alcoholR4: '70度以上禁止托运。',
        alcoholItems: '白酒、红酒、葡萄酒等。',
        otherFoodTitle: '其他食品',
        otherFoodRule: '水产等禁止手提',
      },
      special: {
        wheelchairTitle: '轮椅/婴儿推车',
        airlineRule: '视航空公司和机场安检规定',
        instrumentTitle: '乐器',
        instrumentR1: '体积不超过40CM×60CM×100CM,若超过可为乐器购买占座票',
        instrumentR2: '7公斤以内且体积不超过40CM×60CM×100CM',
        orderAllowanceNote: '以订单行李额规定为准',
        petTitle: '小动物',
        petRule: '视航空公司和机场安检规定,请提前联系机场或航司',
        petNote: '小动物是指家庭饲养的猫,狗等玩赏宠物(野生动物和具有形体怪异或易于伤人等特性的动物如蛇等)',
        liquidMedicineTitle: '液态药品',
        liquidMedicineItems: '胰岛素等(糖尿病患者或其他患者携带必须的液态药品经安全检查确认无疑后,可根据飞行时长适量携带,超量部分必须托运。携带其他药品时最好出具医疗机构的相关证明)',
        pesticideTitle: '农药',
        pesticideR1: '农药成分包含毒害品的如氧化物、砒霜、剧毒农药等剧毒化学品,禁止托运和随身携带',
      },
      tools: {
        knifeTitle: '刀具',
        knifeR1: '管制刀具:刀尖角度小于60度,刀身长度超过150毫米的各类单刃、双刃和多刃刀具',
        knifeR2: '禁止托运',
        sportsTitle: '建筑工具/运动器械',
        categories: {
          professional: '专业刀具',
          professionalItems: '手术刀、雕刻刀、屠宰刀、创刀、铣刀、用作文艺武术表演的的刀、矛、剑、戟等',
          daily: '日常刀具',
          dailyItems: '菜刀、水果刀、剪刀、美工刀、裁纸刀等',
          sports: '运动器械',
          sportsItems: '健身器材、高尔夫球具、滑雪用具、钓鱼用具、指节铜套、登山杖等',
          construction: '建筑工具',
          constructionItems: '凿、锥、锯、螺栓枪、射钉枪、螺丝刀、撬棍、锤、钳、焊枪等',
        },
      },
      footer: {
        endHint: '这里是「行李规定」的末尾啦',
        tapHint: '点击上方分类切换查看不同内容',
        lastChapter: '已经到最后一章啦',
      },
    },

    remind: {
      tabRoute: '航线',
      tabFlight: '航班',
      monitorCount: '今日已为{count}人检测到低价',
      monitor247: '7×24小时监控',
      currentPrice: '当前',
      departDateRange: '{start}至{end}出发',
      departOn: '{date}出发',
      remainOne: '剩1张',
      watchRoutes: '关注的航线',
      watchRoutesTip: '| 航线若降价，立即通知您',
      monitoring: '正在监控',
      priceRising: '预测价格持续上涨 | 尽快购买以防涨价',
      goSee: '去看看',
      swipeEditDelete: '←左滑可删除/编辑监控',
      swipeDelete: '←左滑可删除监控',
      addAlert: '添加低价提醒',
    },

    lowPrice: {
      tabDh: '东航特惠',
      tabNh: '南航低价',
      tabZlh: '中联航低价',
      tabGh: '国航低价',
      tabGlh: '桂林航空低价',
      departWeekday: '{date} {weekday}出发',
    },

    week: {
      title: '{month}月周末拼假',
      monthWeekend: '{month}月周末',
      maxLeaveDays: '最多请假{count}天',
      playDays: '玩{min}-{max}天',
      weekend: '周末',
      askLeave: '请假',
      askDays: '请{count}天',
      playDaysShort: '玩{count}天',
      roundTotal: '往返总价',
      weekN: '第{count}周',
      updatedAt: '更新于{time}',
      moreStrategies: '更多拼假攻略',
      directOnly: '仅看直飞',
      priceLowToHigh: '价格低-高',
      dateEarlyToLate: '日期早-晚',
      goDepart: '{weekday}去',
      returnDepart: '{weekday}回',
    },

    area: {
      title: '地区低价',
      oneWay: '单程',
      roundTrip: '往返',
      dateRange: '{start}~{end}去',
      filter: '筛选',
      moreFlights: '更多航班',
      goWeekday: '{date} {weekday}去',
    },

    intlOrder: {
      fillOrder: '填写订单',
      intlIdOnly: '(仅显示国际证件)',
      unavailableTag: '不可选',
      journeyCount: '(共{count}程)',
      contactEmail: '联系邮箱',
      emailReceiptPlaceholder: '用于接收电子行程单',
      priceLineAdult: '成人￥{ticket} +税￥{tax}',
      priceLineChild: '儿童￥{ticket} +税￥{tax}',
      priceLineInfant: '婴儿￥{ticket} +税￥{tax}',
      priceTimesCopies: '￥{price}×{count}份',
      infantCountShort: '{count}婴儿',
      passengerTypeSelectableLabel: '可选择类型',
      cabinWithTax: '{cabin}（含税）',
      taxExplainTitle: '税费说明',
      taxExplainIntro: '税费包含两项费用：机场建设费和燃油附加费',
      taxFuelIntlTitle: '2.燃油附加费',
      taxFuelIntlBody: '国际航线燃油附加费根据航空公司规定收取，不同航线和航空公司可能有所不同。',
      stopoverPrefix: '经停:',
      intlAccidentInsuranceFallback: '国际航空意外险',
      transferUnknown: '未知',
      transferCalcError: '计算错误',
      personalInfo: {
        sectionInfoUse: '信息使用说明',
        sectionInfoUseBody:
          '您理解，在您预订国内机票时，0息游需将订单信息确认页中涉及的您勾选的产品信息与您输入或勾选的个人信息提供给为您提供服务的境内航空公司；在您预订国际机票时，您的前述个人信息会提供给您预订的境外航空公司，以供其核实您的身份、确认您的订单，并最终为您提供服务。',
        sectionAirlineQuery: '查询航空公司信息',
        sectionAirlineQueryBody:
          '（您可以通过预订页面底部查阅出票方公司名称和营业执照信息，您也可以通过预订详情页面底部的蓝色超链接浏览航空公司运输条件并查询航空公司名称和联系方式）。',
        sectionPrivacy: '个人信息保护政策',
        sectionPrivacyBody:
          '在提供有关信息前，0息游将严格执行《中华人民共和国个人信息保护法》以及0息游《个人信息保护政策》的规定，要求有关服务提供方切实履行个人信息保护义务，仅就提供服务之目的处理您的个人信息，不得擅自转移、共享、提供、出售或基于其他目的处理您的个人信息。',
        sectionContact: '联系方式',
        sectionContactBody:
          '我们还设立了个人信息保护专职部门，有关您个人信息的权利请求，包括个人信息出境场合向境外接收方主张个人信息权利的请求，均可以发送邮件至个人信息保护负责人的邮箱wujinbao{\'@\'}wujinbao.net与我们联系。',
        sectionConsent:
          '请您再次审慎核实确认您勾选的产品信息与您输入或勾选的个人信息。若您点击【提交订单】，表示您同意0息游基于为您提供服务之目的，向有关【境内/境外】服务提供方提供您的个人信息。',
      },
      priceChange: {
        title: '价格已变动',
        desc: '验价发现航司报价发生变化，页面已更新为最新价格，请确认是否继续预定。',
        oldPrice: '原报价',
        newPrice: '最新报价',
        research: '重新查询',
        continueBook: '继续预定',
      },
      toast: {
        passengerTypeUnsupported: '当前航班不支持{type}乘客',
        passengerCardTypeInvalid: '乘客 {names} 的证件类型不符合航空公司要求',
        passengerNationalityInvalid: '乘客 {names} 的国籍不符合航空公司要求',
        passengerNationalityBanned: '乘客 {names} 的国籍被航空公司限制购票',
        passengerAgeInvalid: '乘客 {names} 的年龄不符合航空公司要求',
        fillContact: '请填写联系人',
        selectPhoneAreaCode: '请选择联系电话区号',
        fillPhone: '请填写联系电话',
        phoneDigitsOnly: '联系电话只能包含数字',
        fillEmail: '请填写联系邮箱',
        invalidEmailFormat: '请填写正确的邮箱格式',
        submitFailRetry: '提交订单失败，请稍后重试',
        priceChangedRetry: '价格已变动，请重新查询',
        missingQuote: '缺少报价信息，请返回重试',
        insuranceLoadFail: '获取保险数据失败',
        insuranceLoadFailRetry: '获取保险数据失败，请稍后重试',
      },
    },

    intlOrderDetail: {
      orderNoLabel: '订单号:',
      copy: '复制',
      payRemainTime: '支付剩余时间',
      payRemainHint: '请尽快完成支付，避免订单自动取消',
      refundedAmount: '已退款 ¥{amount}',
      refundEta: '预计退款到账时间: {time}',
      refundProgress: '退款进度',
      totalAmount: '总计 ¥{amount}',
      orderRecord: '订单记录',
      priceDetail: '价格明细',
      refundChangeRules: '退改签规则',
      status: {
        unknown: '未知状态',
        pendingPay: '待付款',
        ticketing: '出票中',
        ticketSuccess: '出票成功',
        ticketFail: '出票失败',
        cancelled: '订单取消',
        partialRefunding: '部分退票中',
        partialRefunded: '部分退票成功',
        refunding: '退票中',
        refunded: '已退票',
      },
      changeFlightInfo: '改签航班信息',
      changePassengers: '改签乘客：',
      transfer: '中转',
      transferWithTime: '中转 {time}',
      viewDetail: '查看详情',
      changePersonCount: '{count}人改签',
      passengerRefund: '{name}退款',
      flightInfo: '航班信息',
      flightLabel: '航班:',
      departLabel: '出发:',
      tripN: '行程{n}',
      journey1: '第一程',
      journey2: '第二程',
      journey3: '第三程',
      journey4: '第四程',
      journey5: '第五程',
      journeyNth: '第{n}程',
      preTravelMustRead: '出行前必读',
      fraudReminder: '防诈骗提醒',
      civilizedBoarding: '文明乘机须知',
      purchasedServices: '已购/赠送服务',
      insurance: '保险',
      purchased: '已购买',
      travelerInfo: '出行人信息',
      ticketNo: '票号:',
      ticketNoValue: '票号: {no}',
      detail: '详情',
      noTravelers: '暂无出行人信息',
      contactTitle: '联系方式',
      contactName: '联系人',
      mobile: '手机号',
      email: '邮箱',
      usedCoupon: '已使用优惠券',
      unionPointTitle: '云闪付积点抵值',
      unionPointUsed: '使用积点',
      unionPointDeduct: '积点抵扣',
      unionPointRefunded: '已返还积点',
      unionPointCount: '{count} 积点',
      goPay: '去支付',
      refundTicket: '退票',
      rebook: '再次预订',
      refundRecords: '退票记录',
      change: '改签',
      issueInvoice: '开发票',
      viewInvoice: '查看发票',
      noRefundRecords: '暂无退票记录',
      noRefundProgressRecords: '暂无退款记录',
      noTimeInfo: '暂无时间信息',
      refundPassengers: '退票乘客:',
      refundSegments: '退票航段:',
      refundAmount: '退款金额:',
      viewProgress: '查看进度',
      ticketPrice: '票价',
      taxFee: '税费',
      serviceFee: '服务费',
      insuranceTotal: '保险总额：',
      couponDeduct: '优惠券抵扣',
      originalPrice: '原价',
      payablePrice: '应付价格',
      eInvoiceSupport: '本次交易支持电子发票',
      ruleTimeHint: '过期时间段文字颜色变成灰色，实际费用请以航空公司规定为准',
      followAirlinePolicy: '以航空公司规定为准',
      carryOn: '随身行李',
      checkedBaggage: '托运行李',
      baggagePiece: '{count}件，每件{weight}{unit}',
      baggageSize: '，尺寸: {size}',
      baggageDesc: '，{desc}',
      fraud: {
        title: '防诈骗提醒',
        alert: '警惕航空出行诈骗',
        typeChange: '退改签诈骗',
        typeChangeBody: '不法分子冒充航空公司客服，谎称航班取消或延误，诱导旅客私下操作退改签，骗取钱财。',
        typeFakeTicket: '虚假购票诈骗',
        typeFakeTicketBody: '不法分子发布虚假特价机票信息，诱导旅客通过非官方渠道付款购票，最终无法出票。',
        typeOverweight: '行李超重诈骗',
        typeOverweightBody: '不法分子冒充机场工作人员，谎称行李超重需额外付费，要求旅客扫码支付。',
        typeFakeClaim: '虚假投诉理赔诈骗',
        typeFakeClaimBody: '不法分子冒充航空公司客服，谎称可以办理投诉赔偿，诱导旅客提供银行卡信息。',
        tipsTitle: '防范提示',
        tip1: '1. 务必通过航空公司官方渠道或可信平台购票、退改签',
        tip2: '2. 不要轻信陌生电话和短信中的退改签通知',
        tip3: '3. 不向陌生人转账或提供银行卡、验证码等敏感信息',
        tip4: '4. 机场付费一律前往官方柜台，切勿扫描可疑二维码',
        tip5: '5. 如遇可疑情况，请立即拨打民航局官方客服或报警',
      },
      civilized: {
        title: '文明乘机须知',
        intro: '为了确保航班安全、准点起降，为所有旅客创造舒适的乘机环境，请遵守以下乘机规范：',
        prepareTitle: '乘机前准备',
        prepare1: '1. 提前了解航班信息，预留充足时间办理乘机手续',
        prepare2: '2. 注意航班动态，关注航班是否有延误或取消信息',
        prepare3: '3. 了解行李限重规定，避免超重或携带违禁物品',
        prepare4: '4. 准备好有效乘机证件，确保证件在有效期内',
        securityTitle: '安检与登机',
        security1: '1. 配合安检人员工作，礼貌接受安全检查',
        security2: '2. 按照登机顺序有序登机，不插队、不拥挤',
        security3: '3. 正确放置随身行李，不占用他人空间',
        security4: '4. 手机设置飞行模式或关机，遵守电子设备使用规定',
        etiquetteTitle: '机上礼仪',
        etiquette1: '1. 系好安全带，遵守机组人员安全指引',
        etiquette2: '2. 不大声喧哗，使用耳机听音乐或观看视频',
        etiquette3: '3. 尊重他人隐私和空间，不随意调整前排座椅',
        etiquette4: '4. 保持机舱清洁，垃圾放入垃圾袋',
        etiquette5: '5. 礼貌对待乘务人员，文明用语提出需求',
        forbidTitle: '严禁行为',
        forbid1: '1. 严禁在机舱内吸烟或使用电子烟',
        forbid2: '2. 严禁酒后闹事或扰乱机舱秩序',
        forbid3: '3. 严禁使用或损坏安全设备',
        forbid4: '4. 严禁干扰机组人员正常工作',
        forbid5: '5. 严禁携带或谎报违禁品',
        legalNote: '根据《中国民用航空法》和《民用航空安全保卫条例》，扰乱客舱秩序、妨碍机组人员履行职责或危及飞行安全的行为将受到处罚，情节严重者将被列入民航旅客不良行为记录。',
      },
      ticketInfo: '出票信息',
      orderChangeRecord: '订单改动记录',
      noOrderChangeRecord: '暂无订单变动记录',
      passengerLabel: '乘客：',
      selectInvoiceType: '选择发票类型',
      insuranceInvoice: '保险发票',
      planeInvoice: '机票发票',
      noInsuranceInvoice: '暂无保险发票信息',
      durationHm: '{h}小时{m}分钟',
      durationH: '{h}小时',
      durationM: '{m}分钟',
      monthDayTime: '{month}月{day}日 {time}',
      free: '免费',
      nonRefundable: '不可退',
      nonChangeable: '不可改',
      priceFrom: '¥{price}起',
      ruleTimeAfterDep: '起飞后 ({date}后)',
      ruleTimeAllBefore: '起飞前全部时间 ({date}前)',
      ruleTimeAny: '任何时间',
      ruleTimeAfterHours: '起飞前{h}小时后 ({date}后)',
      ruleTimeBeforeHours: '起飞前{h}小时前 ({date}前)',
      ruleTimeAfterHoursIncl: '起飞前{h}小时(含)后 ({date}及之后)',
      ruleTimeBeforeHoursIncl: '起飞前(含){h}小时前 ({date}及之前)',
      idType: {
        '1': '身份证',
        '2': '护照',
        '3': '军官证',
        '4': '国际海员证',
        '5': '港澳通行证',
        '6': '台湾通行证',
        '7': '台胞证',
        '8': '回乡证',
        '9': '学生',
        '10': '外国人居留证',
        '11': '其他',
        fallback: '证件',
      },
      refundOrderStatus: {
        '0': '待审核',
        '1': '待确认',
        '2': '已驳回',
        '3': '退票中',
        '4': '已退票',
        '5': '已取消',
      },
      changeOrderStatus: {
        '0': '待审核',
        '1': '待支付',
        '2': '已驳回',
        '3': '出票中',
        '4': '已改签',
        '5': '已取消',
      },
      recordType: {
        '0': '预订航班',
        '1': '申请退票',
        '2': '申请改签',
        unknown: '未知操作',
      },
      unknownPassenger: '未知乘客',
      unknownSegment: '未知航段',
      unknownType: '未知',
      toast: {
        loadDetailFail: '获取订单详情失败',
        loadDetailFailRetry: '获取订单详情失败，请稍后重试',
        payIncomplete: '订单信息不完整，无法支付',
        noOrderNoCopy: '无订单号可复制',
        viewRefundDetail: '查看退款详情',
        noChangeable: '该订单没有可改签的机票',
        noRefundable: '该订单没有可退票的机票',
        rebookIncomplete: '订单信息不完整，无法再次预订',
        rebookNoJourney: '缺少行程信息，无法再次预订',
        navigateFail: '跳转失败，请稍后重试',
        operateFail: '操作异常，请稍后重试',
        cancelSuccess: '取消成功',
        noIdCopy: '无证件号码可复制',
        noTicketCopy: '无票号可复制',
        noPhoneCopy: '无手机号可复制',
        noEmailCopy: '无邮箱可复制',
        refundDetailIncomplete: '退票信息不完整，无法查看详情',
        refundProgressIncomplete: '退款信息不完整，无法查看进度',
        changeDetailIncomplete: '无法查看改签详情，信息不完整',
        detailIncomplete: '信息不完整，无法查看详情',
        insuranceInvoiceFail: '获取保险发票列表失败',
        insuranceInvoiceFailRetry: '获取保险发票列表失败，请稍后重试',
        missingOrderNo: '缺少订单号，无法查询订单',
        noOrderNoInvoice: '订单号不存在，无法查看发票详情',
      },
      dialog: {
        tip: '提示',
        cancelOrder: '是否取消订单',
      },
    },

    intlDetail: {
      layover: '停留{duration}',
      actualRide: '实际乘坐{airline}{flightNo}',
      fareTaxLine: '票价: ¥{ticket} + 税费: ¥{tax}',
      select: '选择',
      ticketIssueFast: '极速出票',
      ticketIssuePriority: '优选出票',
      ticketIssueStandard: '普通出票',
      ticketIssueEconomy: '特惠出票',
      ticketTimeDefault: '标准出票',
      ticketTimeFast: '极速标准(30分钟)',
      ticketTimePriority: '优选标准(60分钟)',
      ticketTimeStandard: '普通标准(2小时)',
      ticketTimeEconomy: '特惠标准(48小时+)',
      cabinPremiumEconomy: '超级经济舱',
      cabinFirst: '头等舱',
      purchaseLimitTitle: '购票限制',
      ageLimit: '年龄限制: {value}',
      allowBuyNationality: '允许购票国籍: {value}',
      prohibitBuyNationality: '禁止购票国籍: {value}',
      ageRequirement: '年龄要求：{value}',
      allowNationality: '允许国籍：{value}',
      restrictNationality: '限制国籍：{value}',
      allowDocument: '允许证件：{value}',
      toast: {
        fetchFail: '获取航班数据失败',
        fetchFailRetry: '获取航班数据失败，请稍后重试',
        missingParams: '缺少必要参数，无法获取航班数据',
      },
    },

    intlList: {
      modifyDate: '修改日期',
      selectedFlights: '已选航班',
      segmentCount: '{count}个航段',
      reselect: '重选',
      flightLabel: '航班:',
      airportLabel: '机场:',
      timeLabel: '时间:',
      transferLabel: '中转:',
      cabinLabel: '舱位:',
      transferInfo: '中转信息',
      transferWait: '中转等待:',
      airportWord: '机场',
      viewAll: '查看全部',
      transferCount: '中转{count}次',
      transferCountTimes: '{count}次',
      transferNth: '中转{n}',
      shareBadge: '共享',
      taxIncluded: '含税',
      layover: '停留 {duration}',
      stopoverDetail: '经停：{detail}',
      timeoutRetry: '查询超时，请重试',
      emptyFiltered: '暂无符合条件的航班，请尝试调整筛选条件',
      reload: '重新加载',
      price: '价格',
      time: '时间',
      flightType: '航班类型',
      directFlight: '直飞',
      transferOnce: '1次中转',
      transferTwiceOrMore: '2次或以上中转',
      filterDep: '起飞: {name}',
      filterArr: '到达: {name}',
      dateSelectTitle: '{journey}日期选择',
      shareTitle: '国际机票·全球特惠',
      toast: {
        timeoutRetryLater: '查询超时，请稍后重试',
        fetchFail: '获取航班数据失败',
        retrying: '网络请求超时，正在进行第{count}次重试...',
        filterError: '筛选过程中发生错误',
        journeyParseFail: '行程信息解析失败',
      },
    },

    intlChangeList: {
      flightCount: '航班数量',
      passengerCount: '乘客人数',
      searchPlaceholder: '搜索航班号/城市',
      noFlights: '暂无航班信息',
      passengerList: '乘客列表',
      segmentList: '航段列表',
      unknownCity: '未知城市',
      unknownAirline: '未知航司',
      unknownCabin: '未知舱位',
      transferCity: '中转城市: {city}',
      layoverTime: '停留时间: {duration}',
      shareFlight: '共享航班',
      stopoverDetail: '经停: {detail}',
      layoverMinutes: '停留{minutes}分钟',
      dataFormatError: '数据格式异常',
      fetchFailed: '获取数据失败',
    },

    intlRefundDetail: {
      segmentInfo: '退票航段信息',
      changeOrderTag: '改签单',
      noPassengerSegments: '没有退票航段信息',
      noSegments: '暂无退票航段信息',
      refundAmount: '退款金额',
      totalPrice: '总价格',
      otherFee: '其他费用',
      refundFee: '退票手续费',
      refundServiceFee: '退票服务费',
      couponDeduction: '优惠券抵扣',
      unionPointRefund: '退还积点',
      unionPointCount: '{count} 积点',
      actualRefund: '实际退款',
      pendingReview: '待审核',
      usedCoupons: '使用的优惠券',
      ticketNo: '票号：{no}',
      refundNote: '退款说明',
      note1: '1. 确认退票后，将无法取消退票申请',
      note2: '2. 确认退票后，将根据航司规则进行退款处理',
      note3:
        '3. 退票成功后，将对投保成功的航段发起保险退款，具体金额请在保险退订记录中查看，当前页退款金额不含保险',
      note4: '4. 退款将在3-7个工作日内退回原支付渠道',
      refundChangeRules: '退改签规则',
      refundRulesTitle: '{type}退票规则',
      changeRulesTitle: '{type}改签规则',
      afterTakeoff: '起飞后',
      beforeTakeoff: '起飞前',
      emptyRules: '以航司规定为准',
      cancelRefund: '取消退票',
      confirmRefund: '确认退票',
      back: '返回',
      free: '免费',
      notAllowed: '不可退/改',
      rejectedFallback: '退款申请被拒绝',
      status: {
        '0': '待审核',
        '1': '待确认',
        '2': '已驳回',
        '3': '退票中',
        '4': '已退票',
        '5': '已取消',
        unknown: '未知',
      },
      statusDesc: {
        '0': '请耐心等待审核',
        '1': '请确认退款金额',
        '2': '退款申请被拒绝',
        '3': '退票处理中，请耐心等待',
        '4': '退款已完成，感谢您的使用',
        '5': '退票申请已取消',
      },
      passengerType: {
        adult: '成人',
        child: '儿童',
        infant: '婴儿',
      },
      idType: {
        '1': '身份证',
        '2': '护照',
        '3': '军官证',
        '4': '国际海员证',
        '5': '港澳通行证',
        '6': '台湾通行证',
        '7': '台胞证',
        '8': '回乡证',
        '9': '学生',
        '10': '外国人居留证',
        '11': '其他',
        fallback: '证件',
      },
      toast: {
        dataIncomplete: '退款数据不完整',
        loadFail: '获取退款详情失败',
        loadFailRetry: '获取退款详情失败，请重试',
        cancelSuccess: '退票申请已取消',
        cancelFail: '取消退票失败',
        cancelFailRetry: '取消退票失败，请重试',
        confirmSuccess: '退票申请已确认',
        confirmFail: '确认退票失败',
        confirmFailRetry: '确认退票失败，请重试',
      },
      dialog: {
        cancelTitle: '取消退票',
        cancelMsg: '确定要取消退票申请吗？',
        confirmTitle: '确认退票',
        confirmMsg: '确认后将无法取消，退款将在3-7个工作日内到账，是否确认？',
      },
    },

    intlChangeDetail: {
      payRemainTime: '支付剩余时间：',
      changeOrderNo: '改签单号：',
      copy: '复制',
      submitTime: '提交时间：',
      flightInfo: '航班信息',
      passengerFallback: '客',
      originalFlight: '原航班',
      newFlight: '新航班',
      ticketNo: '票号：',
      changeInfo: '改签信息',
      changeType: '改签类型：',
      changeNature: '改签性质：',
      voluntary: '自愿改签',
      involuntary: '非自愿改签',
      changeReason: '改签原因：',
      rejectReason: '驳回原因：',
      priceDetail: '价格明细',
      ticketDiff: '票价差：',
      changeFee: '改签手续费：',
      otherFee: '其他费用：',
      insuranceFee: '保险费用：',
      subtotal: '小计：',
      total: '总计：',
      pendingReview: '待审核',
      changeInsurance: '改签保险',
      changeInsuranceService: '改签保险服务',
      viewDetail: '查看详情',
      refundChangeRules: '退改签规则',
      changeRulesTab: '改签规则',
      refundRulesTab: '退票规则',
      emptyChangeRules: '暂无改签规则信息，以航空公司规定为准',
      emptyRefundRules: '暂无退票规则信息，以航空公司规定为准',
      contactInfo: '联系人信息',
      nameLabel: '姓名：',
      mobileLabel: '手机：',
      emailLabel: '邮箱：',
      cancelChange: '取消改签',
      payNow: '立即支付',
      status: {
        '0': '待审核',
        '1': '待支付',
        '2': '已驳回',
        '3': '出票中',
        '4': '已改签',
        '5': '已取消',
        unknown: '未知状态',
      },
      statusDesc: {
        '0': '改签申请正在等待审核',
        '1': '请在规定时间内完成支付',
        '2': '改签申请已被驳回',
        '3': '改签单已支付，正在处理中',
        '4': '改签已完成',
        '5': '改签申请已取消',
      },
      passengerType: {
        adult: '成人',
        child: '儿童',
        infant: '婴儿',
      },
      changeTypeMap: {
        '1': '申请改期',
        '2': '申请升舱',
        '3': '申请改签',
        unknown: '未知类型',
      },
      toast: {
        paramError: '参数错误',
        loadFail: '获取改签详情失败',
        orderNoMissing: '订单号不存在',
        copySuccess: '复制成功',
        cancelSuccess: '取消改签成功',
        cancelFail: '取消改签失败',
        cancelFailRetry: '取消改签失败，请重试',
      },
      dialog: {
        cancelTitle: '确认取消改签',
        cancelMsg: '取消后将不再保留该改签申请',
      },
    },

    intlChange: {
      stepSelectPassenger: '选择乘客航段',
      stepSelectFlight: '选择改签航班',
      stepSubmit: '提交改签申请',
      stepBarSelectPassenger: '选择乘客航段',
      stepBarSelectFlight: '选择改签航班',
      stepBarSubmit: '提交改签申请',
      flowTitle: '改签流程',
      flow1: '选择需要改签的乘机人信息和改签航段信息',
      flow2: '根据改签航段信息查询可改签的航班列表',
      flow3: '选择需要改签的航班信息，提交改签申请',
      flow3Desc: '此时返回改签单号和改签单状态',
      flow4: '等待改签申请审核通过，可获取到具体的改签费用信息',
      flow5: '确认改签则进行改签单支付，也可取消改签',
      flow6: '改签单支付后，订单流转为改签中，此时不能再进行取消',
      changeType: '改签类型',
      voluntary: '自愿改签',
      involuntary: '非自愿改签',
      voluntaryDesc: '乘客主动申请改签',
      involuntaryDesc: '航空公司导致的改签',
      normalOrder: '正常单',
      changeOrder: '改签单',
      selectPassengerSegment: '选择乘客和航段',
      selectChangeOrder: '选择改签单',
      selectSegment: '选择航段',
      segmentTip:
        '同一乘客只能选择同一行程的航段，不同乘客之间必须选择相同的航段且必须拥有已选乘客的所有航段,',
      departed: '已起飞',
      changeOrderTitle: '改签单 #{n}',
      passengerPrefix: '乘客: ',
      changeReason: '改签原因',
      changeReasonPlaceholder: '请输入改签原因',
      changeDate: '改签日期',
      changeDatePlaceholder: '请选择改签日期(默认为今天)',
      changeCabin: '改签舱位',
      cabinTip: '改签仅限于同航班改期或升舱，不能降舱改签',
      cabin: {
        economy: '经济舱',
        premiumEconomy: '超级经济舱',
        business: '商务舱',
        first: '头等舱',
        unknown: '未知舱位',
      },
      backPrevPage: '返回上一页',
      nextStep: '下一步',
      prevStep: '上一步',
      searching: '查询中...',
      noChangeFlights: '暂无可改签航班',
      backModify: '返回修改',
      transferTimes: '{count}次中转',
      totalDuration: '总时长 {duration}',
      waitTime: '等待{duration}',
      taxInclusive: '含税价',
      refundChange: '退改签',
      passengerOriginFlight: '乘客与原航班信息',
      newFlightInfo: '新航班信息',
      cabinTypeLabel: '舱位类型:',
      priceLabel: '价格:',
      directFlight: '直飞',
      submitApply: '提交申请',
      refundChangeRules: '退改签规则',
      changeRules: '改签规则',
      refundRules: '退票规则',
      timePeriod: '时间段',
      fee: '费用',
      followAirline: '以航司规定为准',
      baggageAllowance: '行李额',
      segmentLabel: '航段: {cities}',
      checkedBaggage: '托运: {count}件 {weight}{unit}',
      carryOn: '手提: {count}件 {weight}{unit}',
      tipTitle: '温馨提示',
      tip1: '1. 退改签规定以航空公司规定为准，如有疑问请联系客服',
      tip2: '2. 如遇航班延误/取消，可能符合非自愿退改政策',
      tip3: '3. 办理退改签可能需要支付相应手续费',
      confirm: '确定',
      submitting: '提交中...',
      loading: '加载中...',
      free: '免费',
      notAllowed: '不可改签/退票',
      yuan: '{amount}元',
      hoursMinutes: '{hours}小时{minutes}分钟',
      hoursMinutesSeconds: '{hours}小时{minutes}分钟{seconds}秒',
      afterTakeoff: '起飞后',
      beforeTakeoffAfterInclusive: '起飞前{hours}小时(含)后',
      beforeTakeoffAfter: '起飞前{hours}小时后',
      beforeTakeoffBeforeInclusive: '起飞前{hours}小时(含)前',
      beforeTakeoffBefore: '起飞前{hours}小时前',
      andAfter: '及以后',
      after: '之后',
      andBefore: '及以前',
      before: '之前',
      journeyN: '行程{n}',
      journeySegment: '行程{journey}-航段{segment}',
      journeySegmentFallback: '行程-航段',
      noPassengerInfo: '无乘客信息',
      passengersMore: '{name1}、{name2} 等{count}人',
      passengerNameSep: '、',
      unknown: '未知',
      passengerFallback: '乘客',
      changeTypeMap: {
        '1': '申请改期',
        '2': '申请升舱',
        '3': '申请改签',
        unknown: '未知改签类型',
      },
      toast: {
        loadOrderFail: '获取订单详情失败',
        loadOrderFailRetry: '获取订单详情失败，请重试',
        selectPassengerError: '选择乘客出错',
        childAlone: '儿童不能单独改签，请先选择成人',
        noChangeableSegments: '该乘客没有可改签的航段',
        missingSegments: '该乘客缺少已选乘客的某些航段，无法选择',
        selectPassengerErrorRetry: '选择乘客出错，请重试',
        segmentDeparted: '该航段已起飞，不能选择',
        passengerNotFound: '找不到对应乘客',
        segmentStatusNotAllowed: '该航段状态不允许改签',
        segmentChanging: '该航段正在改签中，无法选择',
        sameJourneyOnly: '同一乘客只能选择同一行程的航段',
        currentMissingSegments: '当前乘客缺少已选乘客的某些航段，无法选择',
        sameSegmentsOnly: '只能选择与已选乘客相同的航段',
        selectSegmentErrorRetry: '选择航段出错，请重试',
        noDowngrade: '不允许降舱改签，请选择相同或更高等级的舱位',
        querySuccess: '查询成功',
        noFlightsModify: '暂无可改签航班，请修改查询条件',
        queryFail: '查询可改签航班失败',
        queryFailRetry: '查询可改签航班失败，请重试',
        operateFail: '操作异常，请重试',
        invalidChangeOrder: '选择的改签单无效',
        selectChangeFlight: '请选择改签航班',
        submitSuccess: '改签申请提交成功',
        submitFail: '改签申请提交失败',
        submitFailRetry: '改签申请提交失败，请重试',
        changeTypeError: '判断改签类型出错',
        noOriginFlight: '无法获取原航班信息',
        selectChangeOrder: '请选择改签单',
        noNewFlight: '无法获取新航班信息',
        selectFlight: '请选择航班',
        noChangeablePassenger: '没有可改签的乘客',
        noSelectablePassenger: '该改签单没有可选择的乘客',
        selectPassengerFirst: '请先选择乘客',
        orderParamError: '订单参数错误',
        selectPassenger: '请选择乘客',
        selectSegment: '请选择航段',
        segmentsMismatch: '{name} 选择的航段与其他乘客不一致，所有乘客必须选择相同的航段',
        inputChangeReason: '请输入改签原因',
        dateFormatReset: '日期格式有误，已设置为当前日期',
        selectCabin: '请选择改签舱位',
        dateEarlierThanPrev: '改签日期早于上一程到达时间，请选择更晚日期',
        dateLaterThanNext: '改签日期晚于下一程出发时间，请选择更早日期',
      },
    },

    intlRefund: {
      loading: '正在加载数据...',
      flowTitle: '退票流程说明',
      readCarefully: '请仔细阅读',
      flow1: '为每位乘机人选择需要退票的航段（可多选）',
      flow2: '填写退票原因',
      flow3: '提交退票申请，进入审核流程',
      rulesTitle: '退票规则',
      ruleBeforeDepartHighlight: '起飞前退票：',
      ruleBeforeDepart: '必须全部航程一起退，不能分开退',
      ruleAfterDepartHighlight: '起飞后退票：',
      ruleAfterDepart: '可以退未使用的航段，但需要按顺序退票',
      statusPartialDeparted: '当前状态：部分航段已起飞',
      statusAllNotDeparted: '当前状态：全部航段未起飞',
      refundType: '退票类型',
      voluntary: '自愿退票',
      involuntary: '非自愿退票',
      voluntaryDesc: '旅客自身原因导致的退票',
      involuntaryDesc: '航空公司原因导致的退票',
      proofFiles: '证明材料',
      normalOrder: '正常单',
      changeOrder: '改签单',
      selectChangeOrder: '请选择需要退票的改签订单',
      noChangeOrders: '暂无可退票的改签订单',
      selectPassengerSegment: '乘机人航段选择',
      selectChangePassengerSegment: '改签单乘机人航段选择',
      multiSegmentTip: '选择航段时，将自动选择其后续所有航段',
      departed: '已起飞',
      dependentSelected: '关联选中',
      journeySegment: '{journey}-航段{segment}',
      journeyN: '行程{n}',
      refundReason: '退票原因',
      reasonType: '退票原因类型',
      reasonTypePickerTitle: '选择退票原因类型',
      reasonTypePlaceholder: '请选择退票原因类型',
      reasonDesc: '退票原因描述',
      reasonDescPlaceholder: '请详细描述退票原因',
      submitting: '提交中...',
      noRefundablePassenger: '当前无可退票乘客',
      selectSegment: '请为乘客选择航段',
      submitApply: '提交退票申请',
      sequenceTitle: '退票顺序提示',
      sequenceSuggest: '建议操作顺序：',
      currentSelect: '当前选择：',
      sequenceWarning: '当前选择可能导致前面航段的退款失效，建议按航段顺序申请退票',
      adjustSequence: '立即调整顺序',
      continueAnyway: '仍要继续',
      reasonOptions: {
        '0': '航程变化，无法出行',
        '1': '航班延误',
        '2': '航班备降',
        '3': '航班取消',
        '4': '病退（身体原因）',
        '5': '重复购票',
        '6': '其他',
      },
      toast: {
        noRefundableContent: '当前订单没有可退票的内容',
        loadOrderFail: '获取订单信息失败',
        loadOrderFailRetry: '获取订单信息失败，请重试',
        segmentDeparted: '该航段已起飞，不能选择',
        dependentSegment: '此航段是关联选中的，请取消选择前面的航段',
        mustRefundAll: '起飞前退票必须全部航程一起退，正在为您自动选择所有航段',
        noRefundablePassenger: '没有可退票的乘客',
        noRefundableChangeOrder: '没有可退票的改签单',
        changeOrderNoPassenger: '该改签单没有可退票的乘客',
        selectSegment: '请为乘客选择航段',
        selectReasonType: '请选择退票原因类型',
        inputReasonDesc: '请输入退票原因描述',
        noTicketNo: '未找到可退票的票号',
        submitSuccess: '退票申请已提交，正在跳转...',
        submitFailRetry: '退票申请提交失败，请重试',
        orderIncomplete: '订单信息不完整',
      },
    },

    intlProgress: {
      travelReminder: '出行提醒',
      travelReminderColon: '出行提醒:',
      fraudReminder: '防诈骗提醒',
      passengerSegmentInfo: '乘客及航段信息',
      refundPrefix: '退￥',
      refundDetail: '退款明细',
      updateDate: '更新日期：{date}',
      fraudBodyPrefix:
        '凡有冒充航空公司以飞机机械故障，航班取消等为由要求您主动回电、下载其他APP、汇款改签等，',
      mayBeFraud: '可能是诈骗',
      fraudBodySuffix:
        '。如需了解航班信息，您可进入0息游机票订单详情页或以航司官网查询为准，如有疑问可联系0息游客服或航司官方客服核实。',
      referenceNote: '*以上信息供您参考',
      gotIt: '知道了',
      totalPrice: '总价格',
      refundableTicketAmount: '可退机票金额',
      deductions: '需扣款项',
      refundFee: '退票费',
      otherFee: '其他费用',
      refundServiceFee: '退票服务费',
      couponDeduction: '优惠券抵扣',
      actualRefund: '实退金额',
      ticketRefunded: '已退票',
      ticketIssued: '已出票',
      unknown: '未知',
      toast: {
        loadProgressFail: '获取退款进度失败',
        loadProgressFailRetry: '获取退款进度失败，请重试',
        loadOrderFail: '获取订单详情失败',
        loadOrderFailRetry: '获取订单详情失败，请重试',
        orderParamError: '订单参数错误',
      },
    },

    toast: {
      uncollectSuccess: '已取消收藏',
      collectSuccess: '已加入收藏，随时查看',
      selectChangePassenger: '请选择需要改期的乘客',
      childAloneChange: '儿童不能单独改期',
      remainingChildAlone: '剩余单个儿童不能单独改期',
      remainingChildrenNoAdult: '剩余儿童不能单独改期',
      sameChangeTime: '改期时间不能和行程出发时间相同',
      noChangeFlightsToday: '当前天没有可改期的航班',
      selectPassenger: '请选择乘机人',
      childNeedsAdult: '儿童不能单独乘机，至少需要一位成人陪同',
      invalidPhone: '请填写正确的联系电话',
      agreeTreaty: '请阅读并同意乘机说明',
      selectPayMethod: '请选择支付方式',
      paymentMethodsLoading: '支付方式加载中，请稍候',
      priceExpired: '当前舱位价格已过期，请重新查询',
      selectPassengerFirst: '请先选择乘机人',
      couponSelected: '已选择优惠券，优惠￥{amount}',
      couponCancelled: '已取消优惠券',
      couponSelectFailed: '选择优惠券失败',
      couponCalcFailed: '计算优惠金额失败',
      couponLoadFailed: '获取优惠券失败',
      addCartSuccess: '已添加到购物车',
      addCartFailed: '添加购物车失败，请稍后重试',
      flightCartInvalid: '航班信息已失效，请重新查询',
      selectCartProduct: '请选择商品',
      networkError: '网络异常，请稍后重试',
      airlineListFailed: '获取航空公司列表失败',
      intlChildLimit: '国际机票每名成人最多可携带1名儿童或婴儿',
      sameCity: '出发地和目的地不能相同',
      completeLeg: '请完善第{n}程的出发地和目的地',
      legSameCity: '第{n}程的出发地和目的地不能相同',
      multiNeedIntlLeg: '多程（非往返）至少需要包含一个国际城市',
      intlMainlandBoth: '国际机票的出发地和目的地不能同时为中国大陆城市',
      domesticChildLimit: '每名成人最多可携带1名儿童或婴儿',
      invalidId: '请输入正确的证件号',
      invalidIdCard: '请输入正确的身份证号',
      fillRequired: '请填写必填信息',
      selectExpiry: '请选择证件有效期至',
      policyholderAge: '投保人年龄必须大于18周岁',
      invalidMobile: '请填写正确的手机号',
      intlNationalityBirthday: '国际机票需填写国籍和出生日期',
      fillSurname: '请填写姓',
      invalidEmail: '请填写正确的邮箱',
      nationalityLoadFailed: '获取国籍列表失败',
      maxMultiSelect: '选项最多可选3个',
      alreadySelected: '您已选择此项了',
      loadCityFailed: '获取城市列表失败',
      loadContinentFailed: '获取大洲列表失败',
      loadCountryFailed: '获取国家列表失败',
      searchFailed: '搜索失败',
      loadAirportFailed: '获取机场列表失败',
      noAirportInfo: '该城市无机场信息，将直接选择城市',
      idVerifyFailed: '身份证验证失败',
      saveSuccess: '新增成功!',
      editSuccess: '修改成功!',
      saveFailed: '保存失败',
      saveFailedRetry: '保存失败，请稍后重试',
      loadPassengerFailed: '获取乘机人信息失败，请稍后重试',
      loadPolicyholderFailed: '获取投保人信息失败，请稍后重试',
      initFailed: '初始化失败，请重试',
      adLoadFailed: '获取广告失败',
      requestTimeout: '请求超时，请稍后重试',
    },
  },
}
